// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"150":"cb778871","225":"ebde9ba5","244":"467f4d91","453":"ea004a9d","696":"b69245ea"}[chunkId] + ".chunk.js";
};